import { z } from 'zod';

export const geoUnitSchema = z.object({
  id: z.coerce.number(),
  name: z.string(),
});

export const geoUnitListSchema = z.array(geoUnitSchema);

export type GeoUnit = z.infer<typeof geoUnitSchema>;
